import { useEffect } from 'react';

declare global {
  interface Window {
    dataLayer: any[];
    gtag: (...args: any[]) => void;
  }
}

interface GoogleAnalyticsProps {
  measurementId?: string;
}

const GoogleAnalytics = ({ measurementId = 'G-X72S1Z5RKE' }: GoogleAnalyticsProps) => {
  useEffect(() => {
    // Only load GA in production or staging environment
    const isProduction = import.meta.env.VITE_BUILD_ENV === 'production';
    const isStaging = import.meta.env.VITE_BUILD_ENV === 'staging';
    const isDebugMode = import.meta.env.VITE_GA_DEBUG === 'true';
    
    if (isProduction || isStaging) {
      console.log('Initializing GA4 with:', {
        measurementId,
        environment: import.meta.env.VITE_BUILD_ENV,
        debugMode: isDebugMode
      });

      // Create script elements
      const gtagScript = document.createElement('script');
      gtagScript.async = true;
      gtagScript.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;

      const dataLayerScript = document.createElement('script');
      dataLayerScript.innerHTML = `
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', '${measurementId}', {
          debug_mode: ${isDebugMode}
        });
      `;

      // Append scripts to document head
      document.head.appendChild(gtagScript);
      document.head.appendChild(dataLayerScript);
    }
  }, [measurementId]);

  return null;
};

export default GoogleAnalytics; 